<template>
  <div class="examLabelsMain">
    <div class="examLabels">
      <div class="examLabelsCenter">
        <el-row style="height: 100%;">
          <el-col :span="6" style="height: 100%;">
            <div style="padding: 10px;border:1px solid #e4e7ed;border-radius: 5px; height:calc(100vh - 135px)">
              <div style="font-weight: bold;font-size: 16px; margin-bottom: 10px;">
                标签类别
              </div>
              <div class="tabLable" :class="{ tabBg: currentIndex == 1 }" @click="changeLable1">
                <!-- tabBg -->
                <span style="vertical-align: bottom">
                  <svg t="1710577409582" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1470" width="16" height="16">
                    <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#999999" p-id="1471"></path>
                    <path d="M285.3632 274.3808h93.8496l133.12 213.6576 132.44928-213.6576h93.8496l-187.6992 286.208v189.0304H473.06752v-189.0304l-187.70432-286.208z" fill="#FFFFFF" p-id="1472"></path>
                  </svg>
                </span>
                <span style="font-size: 16px; margin-left: 10px;">年份 </span>
              </div>
              <div class="tabLable" :class="{ tabBg: currentIndex == 2 }" @click="changeLable2">
                <span style="vertical-align: bottom">
                  <svg t="1710581273606" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17208" width="16" height="16">
                    <path d="M231.204571 833.974857a146.285714 146.285714 0 0 1-46.299428-285.110857l-1.974857 0.658286 0.365714-10.532572A329.216 329.216 0 0 1 365.714286 260.754286L365.714286 263.168a146.285714 146.285714 0 0 1 292.205714-10.971429l0.365714 10.971429v-2.340571a329.142857 329.142857 0 0 1 182.491429 279.405714l0.146286 5.705143-1.536-0.365715a146.285714 146.285714 0 1 1-120.612572 260.608l3.657143 2.56A327.533714 327.533714 0 0 1 512 884.809143a327.753143 327.753143 0 0 1-205.385143-71.826286l-4.534857 2.706286c-20.992 11.702857-45.129143 18.285714-70.875429 18.285714z m408.868572-499.931428l-5.339429 8.777142a146.139429 146.139429 0 0 1-250.733714-8.777142l-1.243429 0.658285a256 256 0 0 0-126.537142 208.969143l7.094857 1.243429a146.285714 146.285714 0 0 1 93.257143 218.258285l1.682285-2.852571A254.317714 254.317714 0 0 0 512 811.739429c61.513143 0 117.979429-21.723429 162.157714-57.929143l-2.267428-4.388572a146.285714 146.285714 0 0 1 97.499428-203.702857l-1.682285 0.365714a255.488 255.488 0 0 0-118.052572-206.262857l-9.654857-5.851428zM804.571429 614.546286a73.142857 73.142857 0 1 0 0 146.285714 73.142857 73.142857 0 0 0 0-146.285714z m-573.366858 0a73.142857 73.142857 0 1 0 0 146.285714 73.142857 73.142857 0 0 0 0-146.285714zM512 190.025143a73.142857 73.142857 0 1 0 0 146.285714 73.142857 73.142857 0 0 0 0-146.285714z" fill="#999999" p-id="17209"></path>
                  </svg>
                </span>
                <span style="font-size: 16px; margin-left: 10px;">来源 </span>
              </div>
              <div class="tabLable" :class="{ tabBg: currentIndex == 3 }" @click="changeLable3">
                <span style="vertical-align: bottom">
                  <svg t="1710581030962" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8192" width="16" height="16">
                    <path d="M218.24 177.92q17.28 0 28.8 12t11.52 28.32v121.92q0 16.32-11.52 28.8t-28.8 12.48H76.16q-16.32 0-28.32-12.48t-12-28.8V218.24q0-16.32 12-28.32t28.32-12h142.08z m732.48 0q16.32 0 28.32 12t12 28.32v121.92q0 16.32-12 28.8t-28.32 12.48H401.6q-16.32 0-28.32-12.48t-12-28.8V218.24q0-16.32 12-28.32t28.32-12h549.12zM218.24 482.24q17.28 0 28.8 12t11.52 28.32v60.48q0 17.28-11.52 29.28t-28.8 12h-60.48q-16.32 0-28.32-12t-12-29.28v-60.48q0-16.32 12-28.32t28.32-12h60.48z m650.88 0q16.32 0 28.32 12t12 28.32v60.48q0 17.28-12 29.28t-28.32 12H401.6q-16.32 0-28.32-12t-12-29.28v-60.48q0-16.32 12-28.32t28.32-12h467.52zM218.24 704.96q17.28 0 28.8 12.48t11.52 28.8v61.44q0 16.32-11.52 28.32t-28.8 12h-60.48q-16.32 0-28.32-12t-12-28.32v-61.44q0-16.32 12-28.8t28.32-12.48h60.48z m650.88 0q16.32 0 28.32 12.48t12 28.8v61.44q0 16.32-12 28.32t-28.32 12H401.6q-16.32 0-28.32-12t-12-28.32v-61.44q0-16.32 12-28.8t28.32-12.48h467.52z" fill="#999999" p-id="8193"></path>
                  </svg>
                </span>
                <span style="font-size: 16px; margin-left: 10px;">分项 </span>
              </div>
              <div class="tabLable" :class="{ tabBg: currentIndex == 4 }" @click="changeLable4">
                <span style="vertical-align: bottom">
                  <svg t="1710581094210" class="icon" viewBox="0 0 1026 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10121" width="16" height="16">
                    <path d="M616.00184 922.88H165.68184A165.76 165.76 0 0 1 10.24184 699.76a58.64 58.64 0 0 1 2.16-5.76 163.6 163.6 0 0 1 25.44-42.16l294.72-482.4a144 144 0 0 1 121.76-68.24h461.28a51.28 51.28 0 0 1 43.44 78.4l-280.72 448a140.32 140.32 0 0 1-120 66.24h-392.8a63.04 63.04 0 0 0-44.96 18.88l-15.2 24.8a61.76 61.76 0 0 0-3.12 19.68 63.36 63.36 0 0 0 63.2 63.2H616.00184a38.24 38.24 0 0 0 32.8-18.16l280.72-448A51.2 51.2 0 1 1 1016.00184 408.48l-280 448.08a140.4 140.4 0 0 1-120 66.32zM194.72184 591.52h363.92a38.56 38.56 0 0 0 32.88-18.16l232-369.76H454.40184a40.4 40.4 0 0 0-34.4 19.28z" fill="#999999" p-id="10122"></path>
                    <path d="M650.80184 350H473.36184a51.28 51.28 0 1 1 0-102.56h177.44a51.28 51.28 0 0 1 0 102.56zM562.08184 493.36H384.72184a51.28 51.28 0 0 1 0-102.56h177.36a51.28 51.28 0 0 1 0 102.56z" fill="#999999" p-id="10123"></path>
                  </svg>
                </span>
                <span style="font-size: 16px; margin-left: 10px;">知识点 </span>
              </div>
            </div>
          </el-col>
          <el-col :span="18">
            <div style="padding: 10px;box-sizing: border-box;">
              <div style="overflow: hidden;">
                <div class="fl">
                  <div style="font-weight: bold;font-size: 16px; margin-bottom: 10px;">
                    标签详情
                  </div>
                </div>
              </div>
              <el-form ref="formSearch" :model="formSearch" :inline="true" size="mini" @submit.native.prevent>
                <el-form-item label="年份" v-if="currentIndex == 1">
                  <el-input style="width:250px;" v-model="formSearch.title" placeholder="请输入内容" @keyup.enter.native="searchYear" clearable @change="searchYear"></el-input>
                </el-form-item>
                <template v-if="currentIndex == 2">
                  <el-form-item label="来源">
                    <el-input style="width:250px;" v-model="formSearch.title1" @keyup.enter.native="searchSource" placeholder="请输入内容" clearable @change="searchSource"></el-input>
                  </el-form-item>
                  <el-form-item label="来源类型">
                    <el-select style="width:250px;" v-model="formSearch.source_type" filterable clearable placeholder="请选择来源类型" @change="searchSource">
                      <el-option v-for="item in sourctTypes" :key="item.id" :label="item.title" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="比赛类型" v-if="formSearch.source_type == 1">
                    <el-select v-model="formSearch.match_type" filterable clearable placeholder="请选择比赛类型" @change="searchSource">
                      <el-option v-for="item in matchTypes" :key="item.id" :label="item.title" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>

                <el-form-item label="来源" v-if="currentIndex == 3" clearable>
                  <el-select style="width:250px;" @change="searchItemize" v-model="formSearch.source_id" filterable clearable placeholder="请选择">
                    <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="分项" v-if="currentIndex == 3">
                  <el-input style="width:250px;" v-model="formSearch.title2" @keyup.enter.native="searchItemize" placeholder="请输入分项名称" clearable @change="searchItemize"></el-input>
                </el-form-item>

                <el-form-item v-if="currentIndex !== 4">
                  <el-button type="primary" size="mini" @click="addTab">新建标签</el-button>
                </el-form-item>
              </el-form>
              <div v-if="currentIndex == 4">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="知识点分组" name="first">
                    <el-form ref="formSearch" @submit.native.prevent :model="formSearch" :inline="true" size="mini">
                      <el-form-item label="所属科目">
                        <el-select style="width:250px;" @change="changeSubject" v-model="formSearch.subject_id" placeholder="请选择" clearable>
                          <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="分组名称">
                        <el-input style="width:250px;" @keyup.enter.native="searchGroup" v-model="formSearch.title3" placeholder="请输入分组名称" clearable @change="searchGroup"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="addTab">新增分组</el-button>
                      </el-form-item>
                    </el-form>
                    <el-table row-key="id" height="calc(100vh - 315px)" :data="tableData" stripe style="width: 100%;" :header-cell-style="{ background: '#f5f7fa' }">
                      <el-table-column prop="sort_num" label="序号" width="80">
                      </el-table-column>
                      <el-table-column prop="subjectName" label="科目" width="150">
                      </el-table-column>
                      <el-table-column prop="title" label="分组名称">
                      </el-table-column>
                      <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                          <el-button type="text" @click="editLable(scope.row)">编辑</el-button>
                          <el-button type="text" @click="del(scope.row)">删除</el-button>

                          <!-- <i class="el-icon-rank"
                                                        style="margin-left:20px; cursor: pointer;color: #409EFF;"></i> -->
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="text-align: right; margin-top: 5px;">
                      <el-pagination @current-change="handleCurrentChange3" :current-page.sync="page_noGrouping" layout="total, prev, pager, next" :total="totalGrouping" :page-size="page_sizeGrouping"></el-pagination>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="知识点标签" name="second">
                    <el-form ref="formSearch" :model="formSearch" :inline="true" @submit.native.prevent size="mini">
                      <el-form-item label="知识分组" clearable>
                        <el-select style="width:250px;" @change="searchTag" v-model="formSearch.group_id" filterable clearable placeholder="请选择">
                          <el-option v-for="item in tableData" :key="item.id" :label="item.title + ' - ' + item.subjectName" :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="知识点">
                        <el-input style="width:250px;" @keyup.enter.native="searchTag" v-model="formSearch.title4" placeholder="请输入知识点名称" clearable @change="searchTag"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="addTab1">新增知识点</el-button>
                      </el-form-item>
                    </el-form>
                    <el-table row-key="id" height="calc(100vh - 345px)" :data="tableData1" stripe style="width: 100%;" :header-cell-style="{ background: '#f5f7fa' }">
                      <el-table-column prop="sort_num" label="序号" width="80">
                      </el-table-column>
                      <el-table-column prop="groupInfo.title" label="所属标签组">
                      </el-table-column>
                      <el-table-column prop="groupInfo.subjectName" label="所属科目">
                      </el-table-column>
                      <el-table-column prop="title" label="知识点">
                      </el-table-column>
                      <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                          <el-button type="text" @click="editLable1(scope.row)">编辑</el-button>
                          <el-button type="text" @click="delTag(scope.row)">删除</el-button>

                          <!-- <i class="el-icon-rank"
                                                        style="margin-left:20px; cursor: pointer;color: #409EFF;"></i> -->
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="text-align: right; margin-top: 5px;">
                      <el-pagination @current-change="handleCurrentChange4" :current-page.sync="page_noTag" layout="total, prev, pager, next" :total="totalTag" :page-size="page_sizeTag"></el-pagination>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div v-else>
                <el-table v-if="showTable" row-key="id" height="calc(100vh - 250px)" :data="tableData" stripe size="mini" style="width: 100%;" :header-cell-style="{
                    background: '#f5f7fa',
                    color: '#606266',
                    'font-size': '14px',
                  }">
                  <el-table-column prop="sort_num" label="序号" width="100">
                  </el-table-column>

                  <!--
                  <el-table-column v-if="currentIndex==1" prop="title" label="年份"> </el-table-column>
                  <el-table-column v-if="currentIndex==2" prop="title" label="来源"> </el-table-column>
                  <el-table-column v-if="currentIndex==3" prop="title" label="分项"> </el-table-column>
-->
                  <el-table-column v-if="currentIndex == 1" prop="title" label="年份">
                  </el-table-column>
                  <el-table-column v-if="currentIndex == 2" prop="title" label="题库来源">
                  </el-table-column>
                  <el-table-column v-if="currentIndex == 3" prop="title" label="分项">
                  </el-table-column>
                  <el-table-column v-if="currentIndex == 2" prop="_source_type" label="类型">
                    <template slot-scope="scope">
                      <div>{{ scope.row._source_type }}</div>
                    </template>
                  </el-table-column>

                  <el-table-column prop="sourceTitle" label="来源" v-if="currentIndex == 3">
                  </el-table-column>

                  <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button type="text" @click="editLable(scope.row)">编辑</el-button>
                      <el-button type="text" @click="del(scope.row)">删除</el-button>
                      <!-- <i class="el-icon-rank"
                                                style="margin-left:20px; cursor: pointer;color: #409EFF;"></i> -->
                    </template>
                  </el-table-column>
                </el-table>
                <div style="text-align: right; margin-top: 5px;">
                  <el-pagination v-if="currentIndex == 1" @current-change="handleCurrentChange" :current-page.sync="page_noYear" layout="total, prev, pager, next" :total="totalYear" :page-size="page_sizeYear"></el-pagination>
                  <el-pagination v-if="currentIndex == 2" @current-change="handleCurrentChange1" :current-page.sync="page_noSource" layout="total, prev, pager, next" :total="totalSource" :page-size="page_sizeSource"></el-pagination>
                  <el-pagination v-if="currentIndex == 3" @current-change="handleCurrentChange2" :current-page.sync="page_noItemize" layout="total, prev, pager, next" :total="totalItemize" :page-size="page_sizeItemize"></el-pagination>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog :title="dialogIsAdd ? '新建分组' : '编辑分组'" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="排序号">
          <el-input-number v-model="form.sort_num" :precision="1" :step="0.1"></el-input-number>
        </el-form-item>
        <el-form-item label="来源" v-if="currentIndex == 3">
          <el-select v-model="form.source_id" filterable clearable placeholder="请选择">
            <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" v-if="currentIndex == 3">
          <el-input v-model="form.title" :disabled="!form.source_id ? true : false" placeholder="请输入名称"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item label="标签名称">
            <el-input v-model="form.title" placeholder="请输入内容"></el-input>
          </el-form-item>
        </div>
        <div v-if="currentIndex == 4">
          <el-form-item label="科目">
            <el-select :disabled="isShow" v-model="form.subject_id" filterable clearable placeholder="请选择">
              <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="来源类型" v-if="currentIndex === 2">
          <el-select v-model="form.source_type" filterable clearable placeholder="请选择来源类型">
            <el-option v-for="item in sourctTypes" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="比赛类型" v-if="currentIndex === 2 && form.source_type == 1">
          <el-select v-model="form.match_type" filterable clearable placeholder="请选择比赛类型">
            <el-option v-for="item in matchTypes" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报名时间" required v-if="currentIndex === 2 && form.source_type == 1">
          <el-input v-model="form.match_sign_info" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="比赛官网" required v-if="currentIndex === 2 && form.source_type == 1">
          <el-input v-model="form.match_url" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="比赛详情" v-if="currentIndex === 2 && form.source_type == 1">
          <!-- <el-input
            v-model="form.match_content"
            placeholder="请输入内容"
          ></el-input>
          <div
            @click="AddOneChoice('t3')"
            v-if="form.show_type === true"
            class="question-title3"
            v-html="form.match_content"
          ></div> -->
          <el-button size="small" @click="showDrawer = true" type="primary" plain>编辑</el-button>
        </el-form-item>
        <el-form-item label="比赛封面" required v-if="currentIndex === 2 && form.source_type == 1">
          <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="1" :file-list="form.imgList" list-type="picture">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip">
              <span style="color: red">推荐尺寸(700*340)</span>
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="dialogVisible1Title" :visible.sync="dialogVisible1" width="500px" :before-close="handleClose1">
      <el-form ref="form" :model="form1" label-width="80px">
        <el-form-item label="排序号">
          <el-input-number v-model="form1.sort_num" :precision="1" :step="0.1"></el-input-number>
        </el-form-item>

        <el-form-item label="所属分组">
          <el-select v-model="form1.group_id" filterable clearable placeholder="请选择" style="width:380px;">
            <el-option v-for="item in options1" :key="item.id" :label="item.title + ' - ' + item.subjectName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="知识点">
          <el-input v-model="form1.title" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit1">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="赛事详情" z-index="1000" :visible.sync="showDrawer" :direction="direction" size="90vw" append-to-body>
      <!-- modal-append-to-body -->
      <!-- v-if="form.show_type === true" -->
      <markdownShow @changeMardown="changeMardownTitleOther" :markdown="form.match_content" @SaveMarkDown="SaveMarkDownTitleOther">
      </markdownShow>
      <!-- <tinymce
          v-else
          ref="title"
          v-model="form.title_other"
          :height="Editor_Height"
        /> -->
    </el-drawer>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import {
  adminAddOrUpdateTestQuestionBankYear,
  adminGetTestQuestionBankYearList,
  adminDeleteTestQuestionBankYear,
  adminGetTestQuestionBankSourceList,
  adminAddOrUpdateTestQuestionBankSourc,
  adminDeleteTestQuestionBankSource,
  adminGetTestQuestionBankSourceListWit,
  adminGetTestQuestionBankSourceTagList,
  addOrUpdateTestQuestionBankSourceTag,
  adminDeleteTestQuestionBankSourceTag,
  adminAddOrUpdateTestQuestionTagGroup,
  adminGetTestQuestionTagGroupList,
  adminDeleteTestQuestionTagGroup,
  adminGetTestQuestionTagGroupListWithoutPage,
  adminAddOrUpdateTestQuestionTag,
  adminGetTestQuestionTagList,
  adminDeleteTestQuestionTag,
  getSubjectList,
} from "@/api/admin.js";
import uploadFile from "@/config/uploadFile";
import markdownShow from "@/components/markdownShow";
export default {
  components: {
    markdownShow,
  },
  data() {
    return {
      showDrawer: false,
      direction: "rtl",
      // Editor_Height: "",
      uploadFileTime: false,
      isShow: true,
      subjectList: [],
      options1: [],

      form1: {
        subject_id: "",
        sort_num: 0,
        group_id: "",
        title: "",
        id: "",
      },
      dialogVisible1: false,
      dialogVisible1Title: "新增知识点",
      activeName: "first",
      options: [],
      formSearch: {
        title: "",
        title1: "",
        title2: "",
        title3: "",
        title4: "",
        source_id: "",
        group_id: "",
        source_type: "",
        match_type: "",
      },
      form: {
        subject_id: "",
        sort_num: 0,
        title: "",
        source_id: "",
        source_type: "",
        match_type: "",
        match_sign_info: "",
        match_url: "",
        match_content: "",
        imgList: [],
      },
      dialogVisible: false,
      tableData: [],
      tableData1: [],
      currentIndex: 1,
      page_noYear: 1,
      page_sizeYear: 10,
      totalYear: 0,
      testQuestionBankYearList: [],
      yearId: "",
      page_noSource: 1,
      page_sizeSource: 10,
      totalSource: 0,
      page_noItemize: 1,
      page_sizeItemize: 10,
      totalItemize: 0,
      page_noGrouping: 1,
      page_sizeGrouping: 1000,
      totalGrouping: 0,
      page_noTag: 1,
      page_sizeTag: 10,
      totalTag: 0,
      sourctTypes: [
        { id: 1, title: '赛考训练' },
        { id: 2, title: '阶段测评' },
        { id: 3, title: '金牌师训' },
      ],
      matchTypes: [
        { id: 1, title: "大赛" },
        { id: 2, title: "考级" },
      ],
      dialogIsAdd: true,
      subject_list: [],
      showTable: true,
    };
  },

  mounted() {
    // this.rowDrop();
    this.adminGetTestQuestionBankYearList();
  },
  methods: {
    refreshTable() {
      this.showTable = false; // 隐藏表格
      this.$nextTick(() => {
        this.showTable = true; // 显示表格，触发重绘
      });
    },

    changeSubject() {
      this.searchGroup();
    },

    changeMardownTitleOther(val) {
      this.form.match_content = val;
    },
    SaveMarkDownTitleOther(md, html) {
      console.log(md, "保存markdown");
      console.log(html, "保存markdown");
      this.form.match_content = md;
    },
    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList);
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true;
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log("上传图片");
          console.log(res);
          this.form.imgList = res;
          this.uploadFileTime = false;
        }
      );
    },
    handleRemove() { },
    uploadFile() { },
    addTab1() {
      this.form1.title = "";
      this.form1.id = "";
      // this.getSubjectList()

      this.form1.group_id = this.formSearch.group_id;
      this.form1.sort_num = this.tableData1.length + 1;

      this.dialogVisible1 = true;
      this.dialogVisible1Title = "新增知识点";
      this.adminGetTestQuestionTagGroupListWithoutPage();
    },
    adminGetTestQuestionTagGroupListWithoutPage() {
      adminGetTestQuestionTagGroupListWithoutPage({ subject_id: this.form1.subject_id }).then((res) => {
        console.log(res, 784563456);
        this.options1 = res.testQuestionTagGroupList;
      });
    },
    changesubject(val) {
      console.log(val, 789465);
      this.form.subject_id = val;
    },
    getSubjectList() {
      getSubjectList({
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.subjectList = res.subject_list;
        console.log("科目列表");
        console.log(this.subjectList, 789465);
      });
    },
    handleClick(val) {
      console.log(val, 12346789);
      if (val.index == "1") {
        this.adminGetTestQuestionTagList();
      }
      // adminGetTestQuestionTagList
    },
    // 行拖拽
    rowDrop() {
      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const that = this;
      console.log(that.tableData, 4547878);
      Sortable.create(tbody, {
        animation: 1000,
        ghostClass: "ghostClass", //设置拖拽停靠样式类名
        chosenClass: "chosenClass", //设置选中样式类名
        handle: ".el-icon-rank",
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          console.log("拖动了行，当前序号：" + newIndex);
          const currentRow = that.tableData.splice(oldIndex, 1)[0];
          that.tableData.splice(newIndex, 0, currentRow);
          console.log(that.tableData, 4578);
        },
      });
    },
    changeLable1() {
      console.log("更改Index1");
      this.currentIndex = 1;
      console.log(this.currentIndex);

      this.searchYear();
    },
    changeLable2() {
      console.log("更改Index2");
      this.currentIndex = 2;
      console.log(this.currentIndex);

      this.searchSource();
    },
    changeLable3() {
      console.log("更改Index3");
      this.currentIndex = 3;
      console.log(this.currentIndex);
      this.adminGetTestQuestionBankSourceListWit();
      this.searchItemize();
    },
    changeLable4() {
      console.log("更改Index4");
      this.currentIndex = 4;
      console.log(this.currentIndex);

      this.adminGetTestQuestionTagGroupList();
      this.getSubjectList();
    },
    addTab() {
      this.dialogIsAdd = true;
      if (this.currentIndex == 3) {
        this.form.title = "";
        this.form.sort_num = 0;
        this.yearId = "";
        this.form.source_id = "";
        this.form.source_type = "";
        this.form.match_type = "";
        this.form.match_sign_info = "";
        this.form.match_url = "";
        this.form.match_content = "";
        this.form.imgList = [];
        this.dialogVisible = true;
        // this.adminGetTestQuestionBankSourceListWit()
      } else {
        console.log(this.currentIndex, 123456789);
        this.form.title = "";
        this.form.sort_num = 0;
        this.yearId = "";
        this.form.source_type = "";
        this.form.match_type = "";
        this.form.match_sign_info = "";
        this.form.match_url = "";
        this.form.match_content = "";
        this.form.imgList = [];
        this.dialogVisible = true;
      }
      if (this.currentIndex == 4) {
        console.log("新增分组");
        console.log(this.totalGrouping);

        this.form.subject_id = this.formSearch.subject_id;
        this.form.sort_num = this.totalGrouping + 1;
        this.isShow = false;
      }
    },
    handleClose() {
      console.log(123415);
      this.dialogVisible = false;
    },
    //新建年份
    submit() {
      if (this.currentIndex == 1) {
        if (this.yearId) {
          adminAddOrUpdateTestQuestionBankYear({
            id: this.yearId,
            title: this.form.title,
            sort_num: this.form.sort_num,
          }).then((res) => {
            console.log(res, 123465);
            this.dialogVisible = false;
            this.adminGetTestQuestionBankYearList();
          });
        } else {
          adminAddOrUpdateTestQuestionBankYear({
            title: this.form.title,
            sort_num: this.form.sort_num,
          }).then((res) => {
            console.log(res, 123465);
            this.dialogVisible = false;
            this.adminGetTestQuestionBankYearList();
          });
        }
      } else if (this.currentIndex == 2) {
        console.log(String(this.form.source_type));
        if (String(this.form.source_type) === "1") {
          if (!this.form.imgList[0]) {
            return this.$message({
              message: "请上传封面",
              type: "warning",
            });
          }
          if (!this.form.match_url) {
            return this.$message({
              message: "请输入比赛官网",
              type: "warning",
            });
          }
          if (!this.form.match_sign_info) {
            return this.$message({
              message: "请输入报名时间",
              type: "warning",
            });
          }
        }
        if (this.yearId) {
          adminAddOrUpdateTestQuestionBankSourc({
            id: this.yearId,
            title: this.form.title,
            sort_num: this.form.sort_num,
            source_type: this.form.source_type, // 来源类型 1赛考训练 2阶段测评 3金牌师训
            match_type: this.form.match_type, // 比赛类型，1大赛 2考级
            match_sign_info: this.form.match_sign_info, // 报名时间
            match_url: this.form.match_url, // 比赛官网
            match_content: this.form.match_content, // 比赛详情
            match_img_url: this.form.imgList[0] ? this.form.imgList[0].url : "", // 比赛图片
          }).then((res) => {
            console.log(res, 123465);
            this.dialogVisible = false;
            this.adminGetTestQuestionBankSourceList();
          });
        } else {
          adminAddOrUpdateTestQuestionBankSourc({
            title: this.form.title,
            sort_num: this.form.sort_num,
            source_type: this.form.source_type, // 来源类型 1赛考训练 2阶段测评 3金牌师训
            match_type: this.form.match_type, // 比赛类型，1大赛 2考级
            match_sign_info: this.form.match_sign_info, // 报名时间
            match_url: this.form.match_url, // 比赛官网
            match_content: this.form.match_content, // 比赛详情
            match_img_url: this.form.imgList[0] ? this.form.imgList[0].url : "", // 比赛图片
          }).then((res) => {
            console.log(res, 123465);
            this.dialogVisible = false;
            this.adminGetTestQuestionBankSourceList();
          });
        }
      } else if (this.currentIndex == 3) {
        if (this.yearId) {
          addOrUpdateTestQuestionBankSourceTag({
            id: this.yearId,
            title: this.form.title,
            source_id: this.form.source_id,
            sort_num: this.form.sort_num,
          }).then((res) => {
            console.log(res, 123465);
            this.dialogVisible = false;
            this.adminGetTestQuestionBankSourceTagList();
          });
        } else {
          addOrUpdateTestQuestionBankSourceTag({
            title: this.form.title,
            source_id: this.form.source_id,
            sort_num: this.form.sort_num,
          }).then((res) => {
            console.log(res, 123465);
            this.dialogVisible = false;
            this.adminGetTestQuestionBankSourceTagList();
          });
        }
      } else if (this.currentIndex == 4) {
        if (this.yearId) {
          adminAddOrUpdateTestQuestionTagGroup({
            id: this.yearId,
            title: this.form.title,
            sort_num: this.form.sort_num,
            subject_id: this.form.subject_id,
          }).then((res) => {
            console.log(res, 123465);
            this.dialogVisible = false;
            this.adminGetTestQuestionTagGroupList();
          });
        } else {
          adminAddOrUpdateTestQuestionTagGroup({
            title: this.form.title,
            sort_num: this.form.sort_num,
            subject_id: this.form.subject_id,
          }).then((res) => {
            console.log(res, 123465);
            this.dialogVisible = false;
            this.adminGetTestQuestionTagGroupList();
          });
        }
      }
    },
    editLable(row) {
      this.dialogIsAdd = false;
      console.log(row, 12346545);
      this.yearId = row.id;
      this.form.title = row.title;
      this.form.sort_num = row.sort_num;
      this.form.source_type = row.source_type;
      this.form.match_type = row.match_type;
      this.form.match_sign_info = row.match_sign_info;
      this.form.match_url = row.match_url;
      this.form.match_content = row.match_content;
      this.form.imgList = [];
      if (row.match_img_url) {
        this.form.imgList = [
          {
            url: row.match_img_url,
            name: row.match_img_url.split("/")[
              row.match_img_url.split("/").length - 1
            ],
          },
        ];
      }
      if (this.currentIndex == 3) {
        // this.adminGetTestQuestionBankSourceListWit()
        this.form.source_id = row.source_id;
      }
      if (this.currentIndex == 4) {
        this.getSubjectList();
      }
      this.form.subject_id = row.subject_id;
      this.dialogVisible = true;
      console.log(row, 12346789);
    },
    //查询年份
    adminGetTestQuestionBankYearList() {
      adminGetTestQuestionBankYearList({
        title: this.formSearch.title,
        page_no: this.page_noYear,
        page_size: this.page_sizeYear,
      }).then((res) => {
        console.log(res, 123465);
        this.tableData = res.testQuestionBankYearList;
        this.totalYear = res.total;
        this.refreshTable();
      });
    },
    handleCurrentChange(val) {
      this.page_noYear = val;
      this.adminGetTestQuestionBankYearList();
    },
    searchYear() {
      this.page_noYear = 1;
      this.adminGetTestQuestionBankYearList();
    },
    del(row) {
      if (this.currentIndex == 1) {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            adminDeleteTestQuestionBankYear({
              id: row.id,
            }).then(() => {
              this.adminGetTestQuestionBankYearList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else if (this.currentIndex == 2) {
        this.$confirm("是否确认删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            adminDeleteTestQuestionBankSource({
              id: row.id,
              ifIgnore: 0,
            }).then((res) => {
              if (res.is_delete === true) {
                this.$message.success("删除成功");
                this.adminGetTestQuestionBankSourceList();
              } else {
                this.$confirm(res.msg, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    adminDeleteTestQuestionBankSource({
                      id: row.id,
                      ifIgnore: 1,
                    }).then(() => {
                      this.$message({
                        type: "success",
                        message: "删除成功!",
                      });
                      this.adminGetTestQuestionBankSourceList();
                    });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消删除",
                    });
                  });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else if (this.currentIndex == 3) {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            adminDeleteTestQuestionBankSourceTag({
              id: row.id,
            }).then(() => {
              this.adminGetTestQuestionBankSourceTagList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else if (this.currentIndex == 4) {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            adminDeleteTestQuestionTagGroup({
              id: row.id,
            }).then(() => {
              this.adminGetTestQuestionTagGroupList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },

    //题库来源
    searchSource() {
      this.page_noSource = 1;
      this.adminGetTestQuestionBankSourceList();
    },
    adminGetTestQuestionBankSourceList() {
      adminGetTestQuestionBankSourceList({
        title: this.formSearch.title1,
        page_no: this.page_noSource,
        page_size: this.page_sizeSource,
        source_type: this.formSearch.source_type, // 来源类型：1赛考训练 2阶段测评 3金牌师训
        match_type: this.formSearch.match_type, // 比赛类型：1大赛 2考级
        match_sign_info: this.formSearch.match_sign_info, // 比赛类型：1大赛 2考级
      }).then((res) => {
        console.log(res, 45);
        res.testQuestionBankSourceList.forEach((testItem) => {
          testItem._source_type =
            testItem.source_type === 1
              ? '赛考训练'
              : testItem.source_type === 2
                ? "阶段测评"
                : testItem.source_type === 3
                  ? "金牌师训"
                  : "";
        });
        this.tableData = res.testQuestionBankSourceList;
        this.totalSource = res.total;
        this.refreshTable();
      });
    },
    handleCurrentChange1(val) {
      this.page_noSource = val;
      this.adminGetTestQuestionBankSourceList();
    },
    //不分页来源查询
    adminGetTestQuestionBankSourceListWit() {
      adminGetTestQuestionBankSourceListWit().then((res) => {
        this.options = res.testQuestionBankSourceList;
      });
    },
    //分项
    adminGetTestQuestionBankSourceTagList() {
      adminGetTestQuestionBankSourceTagList({
        page_no: this.page_noItemize,
        page_size: this.page_sizeItemize,
        title: this.formSearch.title2,
        source_id: this.formSearch.source_id,
      }).then((res) => {
        console.log(res, 123465456);
        this.tableData = res.testQuestionBankSourceTagList;
        this.totalItemize = res.total;
        this.refreshTable();
      });
    },
    searchItemize() {
      this.page_noItemize = 1;
      this.adminGetTestQuestionBankSourceTagList();
    },
    handleCurrentChange2(val) {
      this.page_noItemize = val;
      this.adminGetTestQuestionBankSourceTagList();
    },
    //分组列表
    adminGetTestQuestionTagGroupList() {
      adminGetTestQuestionTagGroupList({
        title: this.formSearch.title3,
        subject_id: this.formSearch.subject_id,
        page_no: this.page_noGrouping,
        page_size: this.page_sizeGrouping,
      }).then((res) => {
        console.log(res);
        this.tableData = res.TestQuestionTagGroupList;
        this.totalGrouping = res.total;
        this.refreshTable();
      });
    },
    searchGroup() {
      this.page_noGrouping = 1;
      this.adminGetTestQuestionTagGroupList();
    },
    handleCurrentChange3(val) {
      this.page_noGrouping = val;
      this.adminGetTestQuestionTagGroupList();
    },
    handleClose1() {
      this.dialogVisible1 = false;
    },

    //新建标签
    submit1() {
      if (this.form1.id) {
        adminAddOrUpdateTestQuestionTag({
          id: this.form1.id,
          title: this.form1.title,
          group_id: this.form1.group_id,
          sort_num: this.form1.sort_num,
        }).then(() => {
          this.dialogVisible1 = false;
          this.adminGetTestQuestionTagList();
        });
      } else {
        adminAddOrUpdateTestQuestionTag({
          title: this.form1.title,
          group_id: this.form1.group_id,
          sort_num: this.form1.sort_num,
        }).then(() => {
          this.dialogVisible1 = false;
          this.adminGetTestQuestionTagList();
        });
      }
    },
    //标签查询
    adminGetTestQuestionTagList() {
      adminGetTestQuestionTagList({
        title: this.formSearch.title4,
        group_id: this.formSearch.group_id,
        page_no: this.page_noTag,
        page_size: this.page_sizeTag,
      }).then((res) => {
        console.log(res, 156456);
        this.tableData1 = res.TestQuestionTagList;
        this.totalTag = res.total;
      });
    },
    editLable1(row) {
      this.form1.title = row.title;
      this.form1.sort_num = row.sort_num;
      this.form1.group_id = row.group_id;
      this.form1.subject_id = row.groupInfo.subjectId;
      this.form1.id = row.id;
      this.dialogVisible1 = true;
      this.dialogVisible1Title = "编辑知识点";
      this.adminGetTestQuestionTagGroupListWithoutPage();
    },
    delTag(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          adminDeleteTestQuestionTag({
            id: row.id,
          }).then(() => {
            this.adminGetTestQuestionTagList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    searchTag() {
      this.page_noTag = 1;
      this.adminGetTestQuestionTagList();
    },
    handleCurrentChange4(val) {
      this.page_noTag = val;
      this.adminGetTestQuestionTagList();
    },
  },
};
</script>

<style lang="scss" scoped>
.examLabelsMain {
  // margin: 10px;
  padding: 10px 10px 10px 10px;
}

.examLabels {
  // margin: 10px;
  margin-top: 0px;
  background: white;
  border-radius: 5px;
  min-height: calc(100vh - 80px);
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}

.examLabelsTop {
  padding: 15px;
  box-sizing: border-box;
  border-radius: 5px;
}

.fl {
  float: left;
}

.topMain {
  padding: 10px;
}

.topBox {
  background: #e7f2ff;
  padding: 30px;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
}

.examLabelsCenter {
  // padding: 0 15px;
  box-sizing: border-box;
  border-radius: 5px;
  // height: calc(100vh - 351px);

  overflow-y: auto;
  // margin-top: 20px;
  box-sizing: border-box;
}

.tabLable {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
}

.tabBg {
  background-color: #e7f2ff;
}

.fr {
  float: right;
}

.el-drawer__wrapper {
  z-index: 2200 !important;
}
/deep/ .markdown_wrapper .mavon-editor {
  height: calc(100vh - 38px);
}
</style>
